module.exports = __webpack_public_path__ + "static/media/Lightbulb.2f11fa4c.png";